<section>
  <!-- navigation -->
  <div class="flex justify-between items-end">
    <div>
      <h1>Dashboard</h1>
    </div>
    <!-- <div>
      <select class="select select-sm select-bordered w-full max-w-xs ">
        <option>This Year</option>
        <option>Acedmic Year</option>
        <option>Calender Year</option>
        <option>Lifetime</option>
        <option>Custom</option>
      </select>
    </div> -->
  </div>
  <!-- navigation -->

  <!-- main -->
  <div class="grid grid-cols-4 grid-rows-3 gap-5 mt-5">
    <!--  -->
    <div class="col-span-1 row-span-1 card p-5 flex flex-col justify-between">
      <div class="text-sm text-zinc-500 flex justify-between items-center">
        <span>Total Students</span>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
          <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-5 flex justify-between items-end">
        <span class="text-xs p-2 bg-green-50 text-green-600 rounded-lg font-semibold"><i
            class="ri-arrow-up-double-line"></i> 25%</span>
        <h2 class="font-semibold text-2xl">178,659</h2>
      </div>
    </div>
    <!--  -->
    <div class="col-span-1 row-span-1 card p-5 flex flex-col justify-between">
      <div class="text-sm text-zinc-500 flex justify-between items-center">
        <span>Total Courses</span>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
          <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-5 flex justify-between items-end">
        <span class="text-xs p-2 bg-red-50 text-red-600 rounded-lg font-semibold"><i
            class="ri-arrow-down-double-line"></i> 25%</span>
        <h2 class="font-semibold text-2xl">18,659</h2>
      </div>
    </div>
    <!--  -->
    <div class="col-span-1 row-span-1 card p-5 flex flex-col justify-between">
      <div class="text-sm text-zinc-500 flex justify-between items-center">
        <span>New Students</span>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
          <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-5 flex justify-between items-end">
        <span class="text-xs p-2 bg-green-50 text-green-600 rounded-lg font-semibold"><i
            class="ri-arrow-up-double-line"></i> 25%</span>
        <h2 class="font-semibold text-2xl">178,659</h2>
      </div>
    </div>
    <!--  -->
    <div class="col-span-1 row-span-1 card p-5 flex flex-col justify-between">
      <div class="text-sm text-zinc-500 flex justify-between items-center">
        <span>Today's Active Students</span>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
          <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-5 flex justify-between items-end">
        <span class="text-xs p-2 bg-green-50 text-green-600 rounded-lg font-semibold"><i
            class="ri-arrow-up-double-line"></i> 25%</span>
        <h2 class="font-semibold text-2xl">178,659</h2>
      </div>
    </div>
    <!--  -->
    <div class="col-span-3 row-span-2 card">

      <div class="grid grid-cols-2 divide-x">
        <div>
          <button class="w-full text-center py-3 text-zinc-300 border-b">
            <p class="text-2xl font-semibold">7000</p>
            <span class="text-xs text-zinc-400">Total Orders</span>
          </button>
        </div>
        <div>
          <button class="w-full text-center py-3 border-b-4 border-b-primary-600 ">
            <p class="text-2xl font-semibold text-primary-600">3000</p>
            <span class="text-xs text-zinc-400">Total Revenue</span>
          </button>
        </div>
      </div>
      <div class="p-5 pb-3">

        <div class="flex justify-end mb-2">
          <select class="select select-sm self-end">
            <option>This Month</option>
            <option>This Year</option>
            <option>Custom</option>
          </select>
        </div>
        
        <app-line-chart [height]="150"></app-line-chart>
      </div>


    </div>
    <!--  -->
    <div class="col-span-1 row-span-1 card p-5 flex flex-col justify-between">
      <div class="text-sm text-zinc-500 flex justify-between items-center">
        <span>Associated</span>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
          <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-5 flex justify-between items-end">
        <span class="text-xs p-2 bg-green-50 text-green-600 rounded-lg font-semibold"><i
            class="ri-arrow-up-double-line"></i> 25%</span>
        <h2 class="font-semibold text-2xl">178,659</h2>
      </div>
    </div>
    <!--  -->
    <div class="col-span-1 row-span-1 card p-5 flex flex-col justify-between">
      <div class="text-sm text-zinc-500 flex justify-between items-center">
        <span>Total Webinars</span>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
          <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-5 flex justify-between items-end">
        <span class="text-xs p-2 bg-green-50 text-green-600 rounded-lg font-semibold"><i
            class="ri-arrow-up-double-line"></i> 25%</span>
        <h2 class="font-semibold text-2xl">178,659</h2>
      </div>
    </div>
    <!--  -->

  </div>

  <div class="mt-5 card">

    <div class=" flex justify-between items-center p-5 border-b">
      <span class="font-semibold">Recent Transactions</span>
      <div class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="hover:text-black "><i class="ri-more-line"></i></div>
        <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-1 shadow border text-sm">
          <li><a>Item 1</a></li>
          <li><a>Item 2</a></li>
        </ul>
      </div>
    </div>

    <div class="overflow-x-auto p-5">
      <table class="table">
        <!-- head -->
        <thead>
          <tr>
            <th>date</th>
            <th>student Name</th>
            <th>mobile no.</th>
            <th>course name</th>
            <th>course type</th>
            <th>amount</th>
          </tr>
        </thead>
        <tbody>

          @for (i of data; track $index) {
            <tr>
              <th>{{i.date}}</th>
              <td>{{i.studentName}}</td>
              <td>{{i.mobile}}</td>
              <td>{{i.courseName}}</td>
              <td>{{i.courseType}}</td>
              <td>{{i.amount}}</td>
            </tr>
          }

        </tbody>
      </table>
    </div>
  </div>


  <!-- main -->




</section>